export default "__VITE_ASSET__VZTJ51s3__"